// extracted by mini-css-extract-plugin
module.exports = {"banner":"text-banner-module--banner--3iXbk","container":"text-banner-module--container--PXk1p","text":"text-banner-module--text--5bXtM"};